export default "__VITE_ASSET__DwS8Au8m__"